// 查询监测系统列表
import request from "@/api/request";

export function listMonitorTable(query) {
  return request({
    url: '/monitor/monitorTable/list',
    method: 'get',
    params: query
  })
}

// 查询监测系统详细
export function getMonitorTable(monitorId) {
  return request({
    url: '/monitor/monitorTable/' + monitorId,
    method: 'get'
  })
}

// 新增监测系统
export function addMonitorTable(data) {
  return request({
    url: '/monitor/monitorTable',
    method: 'post',
    data: data
  })
}

// 修改监测系统
export function updateMonitorTable(data) {
  return request({
    url: '/monitor/monitorTable',
    method: 'put',
    data: data
  })
}

// 删除监测系统
export function delMonitorTable(monitorId) {
  return request({
    url: '/monitor/monitorTable/' + monitorId,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/monitorTable.js